
export default {
    methods: {
        gatherSubjectiveNumbers(subjectiveCountsFromCall, callCount, type) {

            let secondHalfNegativeFirstHalfNegativeCount = Number(subjectiveCountsFromCall[type].first_half_negative_second_half_negative)
            let secondHalfNegativeFirstHalfNeutralCount = Number(subjectiveCountsFromCall[type].first_half_neutral_second_half_negative)
            let secondHalfNegativeFirstHalfPositiveCount = Number(subjectiveCountsFromCall[type].first_half_positive_second_half_negative)
            let secondHalfNeutralFirstHalfNegativeCount = Number(subjectiveCountsFromCall[type].first_half_negative_second_half_neutral)
            let secondHalfNeutralFirstHalfNeutralCount = Number(subjectiveCountsFromCall[type].first_half_neutral_second_half_neutral)
            let secondHalfNeutralFirstHalfPositiveCount = Number(subjectiveCountsFromCall[type].first_half_positive_second_half_neutral)
            let secondHalfPositiveFirstHalfNegativeCount = Number(subjectiveCountsFromCall[type].first_half_negative_second_half_positive)
            let secondHalfPositiveFirstHalfNeutralCount = Number(subjectiveCountsFromCall[type].first_half_neutral_second_half_positive)
            let secondHalfPositiveFirstHalfPositiveCount = Number(subjectiveCountsFromCall[type].first_half_positive_second_half_positive)
            let secondHalfNegativeCount = secondHalfNegativeFirstHalfNegativeCount + secondHalfNegativeFirstHalfNeutralCount + secondHalfNegativeFirstHalfPositiveCount
            let secondHalfNeutralCount = secondHalfNeutralFirstHalfNegativeCount + secondHalfNeutralFirstHalfNeutralCount + secondHalfNeutralFirstHalfPositiveCount
            let secondHalfPositiveCount = secondHalfPositiveFirstHalfNegativeCount + secondHalfPositiveFirstHalfNeutralCount + secondHalfPositiveFirstHalfPositiveCount
      
            return {
      
              callCount: callCount,
              secondHalfNegativeCount: secondHalfNegativeCount,
              secondHalfNeutralCount: secondHalfNeutralCount,
              secondHalfPositiveCount: secondHalfPositiveCount,
      
              secondHalfNegativeFraction: this.calculateSubjectivePercent(secondHalfNegativeCount,callCount),
              secondHalfNeutralFraction: this.calculateSubjectivePercent(secondHalfNeutralCount,callCount),
              secondHalfPositiveFraction: this.calculateSubjectivePercent(secondHalfPositiveCount,callCount),
      
              secondHalfNegativeFirstHalfNegativeFraction: this.calculateSubjectivePercent(secondHalfNegativeFirstHalfNegativeCount,secondHalfNegativeCount),
              secondHalfNegativeFirstHalfNeutralFraction: this.calculateSubjectivePercent(secondHalfNegativeFirstHalfNeutralCount,secondHalfNegativeCount),
              secondHalfNegativeFirstHalfPositiveFraction: this.calculateSubjectivePercent(secondHalfNegativeFirstHalfPositiveCount,secondHalfNegativeCount),
      
              secondHalfNeutralFirstHalfNegativeFraction: this.calculateSubjectivePercent(secondHalfNeutralFirstHalfNegativeCount,secondHalfNeutralCount),
              secondHalfNeutralFirstHalfNeutralFraction: this.calculateSubjectivePercent(secondHalfNeutralFirstHalfNeutralCount,secondHalfNeutralCount),
              secondHalfNeutralFirstHalfPositiveFraction: this.calculateSubjectivePercent(secondHalfNeutralFirstHalfPositiveCount,secondHalfNeutralCount),
      
              secondHalfPositiveFirstHalfNegativeFraction: this.calculateSubjectivePercent(secondHalfPositiveFirstHalfNegativeCount,secondHalfPositiveCount),
              secondHalfPositiveFirstHalfNeutralFraction: this.calculateSubjectivePercent(secondHalfPositiveFirstHalfNeutralCount,secondHalfPositiveCount),
              secondHalfPositiveFirstHalfPositiveFraction: this.calculateSubjectivePercent(secondHalfPositiveFirstHalfPositiveCount,secondHalfPositiveCount),
      
              secondHalfNegativeFirstHalfNegativeCount: secondHalfNegativeFirstHalfNegativeCount,
              secondHalfNegativeFirstHalfNeutralCount: secondHalfNegativeFirstHalfNeutralCount,
              secondHalfNegativeFirstHalfPositiveCount: secondHalfNegativeFirstHalfPositiveCount,
      
              secondHalfNeutralFirstHalfNegativeCount:secondHalfNeutralFirstHalfNegativeCount,
              secondHalfNeutralFirstHalfNeutralCount: secondHalfNeutralFirstHalfNeutralCount,
              secondHalfNeutralFirstHalfPositiveCount:secondHalfNeutralFirstHalfPositiveCount,
      
              secondHalfPositiveFirstHalfNegativeCount:secondHalfPositiveFirstHalfNegativeCount,
              secondHalfPositiveFirstHalfNeutralCount: secondHalfPositiveFirstHalfNeutralCount,
              secondHalfPositiveFirstHalfPositiveCount: secondHalfPositiveFirstHalfPositiveCount,
            }
          },
          calculateSubjectivePercent(s,t) {
            if (t == 0) {
              return 0
            } else {
              return (s/t*100)/100
            }
          },
          getGlyphSubjective(subjectiveVal, locationBeginning) {
            if (subjectiveVal <.5 && locationBeginning) return 0
            if (subjectiveVal >=.5 && subjectiveVal < .55 && locationBeginning) return 3
            if (subjectiveVal >=.55 && subjectiveVal && locationBeginning) return 6

            if (subjectiveVal <.5) return 0
            if (subjectiveVal >=.5 && subjectiveVal < .55) return 1
            if (subjectiveVal >=.55 && subjectiveVal) return 2
          },
          callScorecardInsightRow(row) {
            let scorecardRow = {}
            scorecardRow.catId = row.id
            if (row.scoring_rule == 2) {
                scorecardRow.catTitle = row.title;
                scorecardRow.subcatTitle = "";
                scorecardRow.primary = true;
                scorecardRow.catScoringRule = row.scoring_rule;
                scorecardRow.catInsightChannel = row.insight_channel
                scorecardRow.catInsightMetric = row.insight_metric
                scorecardRow.catLocationBeginning = row.location_beginning
                scorecardRow.insightCategory = row.insight_category
          
                  if (row.insight_metric == 0 || row.insight_metric == 1) {
                    scorecardRow.catSubjectiveValue = row.subjective_value
                    scorecardRow.catSubjectiveIndex = this.getGlyphSubjective(row.subjective_value, row.location_beginning)
                  } else {
                    scorecardRow.catInsightPercent = row.insight_percent
                  }
              }

              return scorecardRow
          }
    },
    
}